import { render } from "./TargetCustomersSection.vue?vue&type=template&id=0970b95d&scoped=true"
const script = {}

import "./TargetCustomersSection.vue?vue&type=style&index=0&id=0970b95d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0970b95d"]])

export default __exports__